import React from "react";
import {
  imageCodes,
  titleCodes,
  textCodes,
  videoCodes,
} from "../../template_codes/bond/home_page_codes";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/bond/bond_logo.png";
import banner from "../../assets/images/bond/banner.png";

function Home() {
  return (
    <React.Fragment>
      <div class="navbar ">
        <div class="navbar-start"></div>
        <div class="navbar-center lg:flex">
          <ul class="menu menu-horizontal">
            <li className="p-1">
              <Link to={paths.home}>Home</Link>
            </li>
            <li>
              <a href="https://bondmyanmar.com/">Shop</a>
            </li>
            <li className="p-1">
              <Link to={paths.membership}>Membership</Link>
            </li>
            <li className="p-1">
              <Link to={paths.contact}>Contact</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end"></div>
      </div>

      {/*                       banner section                */}
      <div className=" hero w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
        <img
          src={banner}
          className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full"
        />
        <div class="hero-content text-center text-neutral-content">
          <div class="max-w-md">
            <h1 className="text-md lg:text-2xl xl:text-2xl pt-10 lg:pt-40 xl:pt-40 text-white text-[#000000] py-4"></h1>
            <button className="btn btn-outline btn-white btn-xs lg:btn-sm xl:btn-md btn-outline text-[#000000]">
              <a href="https://bondmyanmar.com/"> S h o p N o w </a>
            </button>
          </div>
        </div>
      </div>

      {/*                      end of banner section                */}

      {/*                         About us                     */}

      <div className="container w-4/5 text-center pt-10">
        <h1 className="text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold">
          {titleCodes.About.title}
        </h1>
        <p className="px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center">
          {textCodes.text.text}
        </p>
      </div>

      {/*                   end of about us                     

      {/*                       category section                */}
      <div className="hero w-full h-52 lg:h-1/3 xl:h-1/3 pt-10">
        <h1 className="text-xl lg:text-2xl xl:text-2xl text-center pb-10 font-semibold">
          Categories
        </h1>
      </div>
      <div class="container carousel carousel-center xl:carousel-center l:carousel-center p-4 space-x-10 w-4/5">
        <div class="carousel-item">
          <a href="">
            <img
              src={imageCodes.catego.image}
              className="rounded-full  w-40 h-40 place-items-center"
            ></img>
            <p className="text-md text-base md:pt-4 text-center">BOND Powder</p>
          </a>
        </div>
        <div class="carousel-item">
          <a href="">
            <img
              src={imageCodes.catego1.image}
              className="rounded-full w-40 h-40 place-items-center"
            ></img>
            <p className="text-md text-base md:pt-4 text-center">BOND Wash</p>
          </a>
        </div>
        <div class="carousel-item">
          <a href="">
            <img
              src={imageCodes.catego2.image}
              className="rounded-full  w-40 h-40 place-items-center"
            ></img>
            <p className="text-md text-base md:pt-4 text-center">BOND Wipes</p>
          </a>
        </div>
        <div class="carousel-item">
          <a href="">
            <img
              src={imageCodes.catego3.image}
              className="rounded-full  w-40 h-40 place-items-center"
            ></img>
            <p className="text-md text-base md:pt-4 text-center">
              BOND in BLACK
            </p>
          </a>
        </div>
        <div class="carousel-item">
          <a href="">
            <img
              src={imageCodes.catego4.image}
              className="rounded-full w-40 h-40 place-items-center"
            ></img>
            <p className="text-md text-base md:pt-4 text-center">
              LIMITED EDITION
            </p>
          </a>
        </div>
      </div>
      {/*                      end of category section                

      {/*                        hero product section             */}
      <div className="w-fix">
        <div className="grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 pb-20 lg:px-20 xl:px-20 px-4 pt-10">
          <div className="pt-5 lg:pl-2 xl:pl-2">
            <img src={imageCodes.hero.image}></img>
            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"></a>
          </div>
          <div className="text-center lg:pt-40 xl:pt-40 lg:pr-2 xl:pr-2 focus-visible">
            <h1 className="pr-2 lg:text-2xl xl:text-2xl">
              {" "}
              🟫Limited Edition🟫
            </h1>
            <p className="text-sm pt-5 lg:text-xl xl:text-xl lg:pt-10 xl:pt-10">
              အနံ့ - ချိုမြိန်တယ် အေးမြတယ် နူးညံ့တယ် အထိအတွေ့က အေးမြမွှေးပျံ့တဲ့
              ခံစားချက် Vanilla Caramel ပါဝင်တာမို့ ချိုချိုအေးအေးလေးပါ😋 BINGSU
              သုံးရတဲ့ခံစားချက်က 7Star Hotel ပေါ်မှာ ဘူးဖေးအဝစားပြီးတဲ့အချိန်
              အချိုပွဲ ရေခဲမုန့်စားလိုက်ရသလိုခံစားချက်ပါပဲ။
            </p>
          </div>
        </div>
      </div>
      {/*                        end of hero product section         */}

      {/*               membership section       */}
      <div className="container py-10 mt-16 w-5/6">
        <div className="container grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
        <div className="md:px-8 lg:px-8 xl:px-8 2xl:px-8 md:pt-4 lg:pt-0 xl:pt-0 2xl:pt-0">
            <p className="tracking-wider leading-loose text-justify">
              {textCodes.Join1.text}
            </p>
            <h1 className="text-3xl font-semibold xl:pb-8 pb-4">
              {titleCodes.memberHome.title}
            </h1>
            <p className="font-semibold leading-loose text-justify pb-4 ">
              {textCodes.earnPointsHome.text}
            </p>
            <p className="pb-4  leading-loose text-justify">
              {textCodes.loyaltyDesHome.text}
            </p>
            <Link to={paths.membership}>
              <button className="btn btn-outline">JOIN NOW</button>
            </Link>
          </div>
          <div className="place-content-end ...">
            <img
              src={imageCodes.memberPhoto.image}
              alt="Digital Membership"
              className="place-content-end ..."
            ></img>
          </div>
          
        </div>
      </div>
      {/*               membership section       */}
      {/*                 best seller section                */}
      <div className="w-fix">
        <div className="pt-10 lg:pt-10 xl:pt-10">
          <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">
            Best Seller Products
          </h1>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 lg:px-20 xl:px-20 px-4">
          <div className="lg:pr-2 xl:pr-2 px-1 focus-visible">
            <img src={imageCodes.besSel.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">BOND WASH RED 200mL</p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.hero.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">
                [Limited Edition] BOND Wash BINGSU 75mL
              </p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.besSel2.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">BOND Wipes ၁ဝရွက်</p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.product.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">
                [BOND in BLACK] BOND Wash 120mL RED
              </p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.besSel1.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">BOND POWDER 100g</p>
            </a>
          </div>
        </div>
      </div>
      {/*                  end of best seller section                */}

      {/*                        limited collections section       */}
      <div className="w-fix">
        <div className="pt-10 lg:pt-10 xl:pt-10">
          <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">
            BOND in BLACK
          </h1>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 lg:px-20 xl:px-20 px-4">
          <div className="lg:pr-2 xl:pr-2 px-1 focus-visible">
            <img src={imageCodes.product.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">
                BOND Wash 120mL RED ───
              </p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.product1.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">
                BOND Wash 120mL BLUE ───
              </p>
            </a>
          </div>
          <div className="lg:pl-2 xl:pl-2 px-1">
            <img src={imageCodes.product2.image}></img>
            <a href="">
              <p className="py-4 hover:animate-bounce">
                BOND Wash 120mL GOLD ───
              </p>
            </a>
          </div>
        </div>
      </div>
      {/*                        end of limited collections section                        */}
    </React.Fragment>
  );
}

export default Home;
